module.exports = __webpack_public_path__ + "static/media/CaberjIntegral.deca5fe3.png";